import moment from 'moment';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { requestEndedPresales } from '../../redux/actions';
import { StoreState } from '../../redux/state';
import { Presale } from '../../redux/state/presales';
import { dataTableOptions } from '../ui/DataTableOptions';

interface DispatchProps {
  getEndedPresales: (limit: number, offset: number, query: string) => void;
}

interface ListEndedPresaleProps extends Presale, DispatchProps {}

class ListEndedPresales extends React.Component<ListEndedPresaleProps> {
  constructor(public readonly props: ListEndedPresaleProps) {
    super(props);
  }

  componentDidMount() {
    this.props.getEndedPresales(100, 0, '');
  }

  render() {
    const columns = [
      {
        name: 'id',
        label: 'ID',
      },
      {
        name: 'player',
        label: 'Player',
      },
      {
        name: 'price',
        label: 'Price (€)',
      },
      {
        name: 'total',
        label: 'Total (€)',
      },
      {
        name: 'total24',
        label: 'Total 24h (€)',
      },
      {
        name: 'start',
        label: 'Start',
      },
      {
        name: 'end',
        label: 'End',
      },
      {
        name: 'solidary',
        label: 'Solidary',
      },
    ];

    const data: any[] = [];

    if (this.props.endedPresaleList.data) {
      for (const item of this.props.endedPresaleList.data.data) {
        data.push({
          id: item.id,
          player: item.pack.items[0].user.name + ' ' + item.pack.items[0].user.surname,
          price: item.price,
          total: item.price * item.pack.items[0].total,
          total24: item.price * item['last24'],
          start: moment(item.start).format('YYYY-MM-DD HH:mm'),
          end: moment(item.end).format('YYYY-MM-DD HH:mm'),
          solidary: item.foundationBeneficiaryPercentage + '%',
        });
      }
    }

    const count = this.props.endedPresaleList.data ? this.props.endedPresaleList.data.count : 0;

    const options = {
      ...dataTableOptions,
      count: count,
      sort: true,
      isLoading: this.props.endedPresaleList.isFetching,
      onTableChange: (action, tableState) => {
        const search = tableState.searchText == null ? '' : tableState.searchText;
        this.props.getEndedPresales(tableState.rowsPerPage, tableState.rowsPerPage * tableState.page, search);
      },
    };

    let body;

    if (this.props.endedPresaleList.error) {
      body = (
        <div className='card card-inverse card-danger'>
          <div className='card-body'>
            <h3 className='card-title'>Error fetching ended presales</h3>
            <p className='card-text'>
              There was an error downloading the ended presale list. Please, try again in a few minutes.
            </p>
            <button
              className='btn btn-inverse'
              onClick={() => {
                this.props.getEndedPresales(10, 0, '');
              }}
            >
              Try again
            </button>
          </div>
        </div>
      );
    } else {
      body = (
        <div className='row'>
          <div className='col-12'>
            <div className='card'>
              <div className='card-body'>
                <h4 className='card-title'>Ended Presales</h4>
                <h6 className='card-subtitle'>List ended presales</h6>
                <div className='table-responsive'>
                  <MUIDataTable data={data} columns={columns} options={options} />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className='container-fluid'>
        <div className='row page-titles'>
          <div className='col-md-5 align-self-center'>
            <h3 className='text-themecolor'>Ended Presales</h3>
            <ol className='breadcrumb'>
              <li className='breadcrumb-item'>Ended Presales</li>
              <li className='breadcrumb-item active'>List ended presales</li>
            </ol>
          </div>
        </div>

        {body}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>): DispatchProps => {
  return {
    getEndedPresales: (limit: number, offset: number, query: string) =>
      dispatch(requestEndedPresales(limit, offset, query)),
  };
};

export default connect<Presale, DispatchProps>(
  (store: StoreState) => store.presale,
  mapDispatchToProps
)(ListEndedPresales);
